import { SEVERITY_TIER_CONFIG, SeverityTier } from "../types";

export function getSeverityColor(tier: SeverityTier): string {
  return SEVERITY_TIER_CONFIG[tier].color;
}

export function getSeverityBackgroundColor(tier: SeverityTier): string {
  return SEVERITY_TIER_CONFIG[tier].backgroundColor;
}

export function getSeverityLabel(tier: SeverityTier): string {
  return SEVERITY_TIER_CONFIG[tier].label;
}

export type MatchRateLevel = "excellent" | "good" | "warning" | "critical";

export function getMatchRateLevel(rate: number): MatchRateLevel {
  if (!Number.isFinite(rate)) return "critical";
  if (rate >= 98) return "excellent";
  if (rate >= 95) return "good";
  if (rate >= 80) return "warning";
  return "critical";
}

const MATCH_RATE_COLORS: Record<MatchRateLevel, { color: string; backgroundColor: string }> = {
  excellent: { color: "#15803d", backgroundColor: "#dcfce7" },
  good: { color: "#a16207", backgroundColor: "#fef9c3" },
  warning: { color: "#c2410c", backgroundColor: "#fed7aa" },
  critical: { color: "#991b1b", backgroundColor: "#fecaca" },
};

export function getMatchRateColor(rate: number): { color: string; backgroundColor: string } {
  return MATCH_RATE_COLORS[getMatchRateLevel(rate)];
}
